import React, { Component } from 'react';
import { CheckBox } from '../common/forms';
import { LabelWithArrow, Load } from '../common/basic';
import DropDown from '../common/dropDownOne';
import ReactDom from 'react-dom';
import axios from 'axios';
import { Radio } from 'react-bootstrap';
import dateHelper from '../../helpers/date';
import ReactModal from 'react-modal';

import ScheduleChooseDatesContainer from './ScheduleChooseDatesContainer';

var tmpRepeatDates = [];
var tmpRepeatDay = [];

module.exports = class ScheduleComponent extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            RepeatDates: '',
            RepeatDay: '',
            RepeatType: '',
            showModal: false
        }

        this.handleOpenModal = this.handleOpenModal.bind(this);
        this.handleCloseModal = this.handleCloseModal.bind(this);
        this.onChange = this.onChange.bind(this);
        this.handleSave = this.handleSave.bind(this);
    }

    changeValues(RepeatType, RepeatDay, RepeatDates) {
        this.setState({
            RepeatType: RepeatType,
            RepeatDay: RepeatDay,
            RepeatDates: RepeatDates
        });
    }

    handleSave() {

        if (this.state.RepeatType == "WEEKLY" && !(["1", "2", "3", "4", "5", "6", "7"].includes(tmpRepeatDay))) {
            tmpRepeatDay = "2";
        } else if (this.state.RepeatType == "BIWEEKLY" && !(Array.isArray(tmpRepeatDay) && tmpRepeatDay.length == 2)) {
            tmpRepeatDay = [2, 5];
        } else if (this.state.RepeatType == "MONTHLY" && !(Array.isArray(tmpRepeatDay) && tmpRepeatDay.length == 1)) {
            tmpRepeatDay = [31];
        } else if (this.state.RepeatType == "FREE" && !(Array.isArray(tmpRepeatDates) && tmpRepeatDates.length > 0)) {
            tmpRepeatDates = [Date()];
        }


        if (this.state.RepeatType == "FREE") {
            this.setState({
                RepeatDates: tmpRepeatDates
            });
        }
        else {
            this.setState({
                RepeatDay: tmpRepeatDay
            })
        }

        this.props.onChange(this.state.RepeatType, tmpRepeatDay, tmpRepeatDates);

        this.handleCloseModal();
    }

    handleOpenModal() {
        this.setState({ showModal: true });
    }

    handleCloseModal() {
        this.setState({ showModal: false });
    }

    changeSelectedType(RepeatType, e) {
        this.setState({
            RepeatType: RepeatType
        })
    }

    onChange(val) {
        if (this.state.RepeatType == "FREE") {
            tmpRepeatDates = val;
            //  this.props.onChange(this.state.RepeatType, val, []);
        }
        else {
            tmpRepeatDay = val;

            //this.props.onChange(this.state.RepeatType, [], val);
        }
    }

    render() {

        return (
            <div className='chooseSchedule'>
                <ReactModal
                    isOpen={this.state.showModal}
                    contentLabel="onRequestClose Example"
                    onRequestClose={this.handleCloseModal}
                    className="Modal-Popup"
                    overlayClassName="Modal-Overlay">

                    <h3>Choose Schedule Type</h3>
                    <Radio checked={this.state.RepeatType == "DAILY"} onChange={(e) => this.changeSelectedType("DAILY", e)}>Daily</Radio>
                    <hr />

                    <Radio checked={this.state.RepeatType == "WEEKLY"} onChange={(e) => this.changeSelectedType("WEEKLY", e)}>Weekly</Radio>
                    <ScheduleChooseDatesContainer RepeatType='WEEKLY' RepeatDay={this.state.RepeatType == 'WEEKLY' ? this.state.RepeatDay : ''} className={this.state.RepeatType == "WEEKLY" ? '' : 'hidden'} onChange={this.onChange} />

                    <Radio checked={this.state.RepeatType == "BIWEEKLY"} onChange={(e) => this.changeSelectedType("BIWEEKLY", e)}>Biweekly</Radio>
                    <ScheduleChooseDatesContainer RepeatType='BIWEEKLY' RepeatDay={this.state.RepeatType == 'BIWEEKLY' ? this.state.RepeatDay : ''} className={this.state.RepeatType == "BIWEEKLY" ? '' : 'hidden'} onChange={this.onChange} />

                    <Radio checked={this.state.RepeatType == "MONTHLY"} onChange={(e) => this.changeSelectedType("MONTHLY", e)}>Monthly</Radio>
                    <ScheduleChooseDatesContainer RepeatType='MONTHLY' RepeatDay={this.state.RepeatType == 'MONTHLY' ? this.state.RepeatDay : ''} className={this.state.RepeatType == "MONTHLY" ? '' : 'hidden'} onChange={this.onChange} />

                    <hr />
                    <Radio checked={this.state.RepeatType == "FREE"} onChange={(e) => this.changeSelectedType("FREE", e)}>Free</Radio>
                    <ScheduleChooseDatesContainer RepeatType='FREE' RepeatDates={this.state.RepeatType == 'FREE' ? this.state.RepeatDates : ''} className={this.state.RepeatType == "FREE" ? '' : 'hidden'} onChange={this.onChange} />
                    <br />

                    <button onClick={this.handleSave}>Save</button> <button onClick={this.handleCloseModal}>Cancel</button>
                </ReactModal>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./modules/doctorAdvice/ScheduleComponent.jsx